module.exports = __webpack_public_path__ + "img/cancel-red.740ab77e.svg";